<script setup lang="ts">
import { ref, watch } from "vue";
import { usePwaInstall } from "@/composables/pwa-install";

const { showIosInstructions, closeIosInstallInstructions } = usePwaInstall();
const dialog = ref< HTMLDialogElement >();

watch( showIosInstructions, ( show ) => {
    if ( show ) {
        dialog.value?.showModal();
    } else {
        dialog.value?.close();
    }
} );

function onClose() {
    closeIosInstallInstructions();
}
</script>

<template>
  <dialog ref="dialog" class="modal" @close="onClose">
    <div class="modal-box max-w-sm">
      <form method="dialog">
        <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
      </form>
      <h3 class="text-xl font-bold">Install App</h3>
      <p class="py-3 text-sm text-base-content/70">Add this app to your home screen for quick access.</p>
      <ol class="steps steps-vertical">
        <li class="step">
          <span>Tap the <strong>Share</strong> button <i class="pi pi-arrow-up-from-line text-primary"></i> in Safari's toolbar</span>
        </li>
        <li class="step">
          <span>Scroll down and tap <strong>"Add to Home Screen"</strong></span>
        </li>
        <li class="step">
          <span>Tap <strong>"Add"</strong> to confirm</span>
        </li>
      </ol>
      <div class="modal-action">
        <form method="dialog">
          <button class="btn btn-primary">Got it</button>
        </form>
      </div>
    </div>
    <form method="dialog" class="modal-backdrop">
      <button>close</button>
    </form>
  </dialog>
</template>
